import { Pipe, PipeTransform } from '@angular/core';
import { Header, HeaderDefault } from '@components/header/models';

@Pipe({ name: 'isHeaderDefault', standalone: true })
export class IsHeaderDefaultPipe implements PipeTransform {
  transform(value: Header): value is HeaderDefault {
    return value.type === 'default';
  }
}
